/*
@author: Nikhil 

jvKeyboardEvents
============
@desc: Add listeners for  keyboard events 

 */
angular.module('jv.Common.keyboardEvents.directive', [])
.directive('jvKeyboardEvents', ['$timeout', function($timeout){
        var keyMap = {
            38: 'arrowUpKeyListener',
            27: 'escapeKeyListener',
            40: 'arrowDownKeyListener',
            32: 'spaceKeyListener',
            13: 'enterKeyListener',
            9: 'tabKeyListener'
        }
        var directiveDefinitionObject = {
            scope:{
                arrowUpKeyListener: '&',
                arrowDownKeyListener: '&',
                escapeKeyListener: '&',
                spaceKeyListener: '&',
                enterKeyListener: '&',
                tabKeyListener: '&'
            },
            link: function($scope, element, attributes) {
                const keydownHandler = function(e) {
                    var keyHandler;
                    if (keyMap[e.which]) {
                        keyHandler = keyMap[e.which];
                        if (attributes[keyHandler]) {
                            $timeout($scope[keyHandler]);
                            e.preventDefault();
                        }
                    }
                };
                if (parseFloat(jQuery.fn.jquery) <= 1.3) {
                    element.keydown(keydownHandler);
                } else {
                    element.on('keydown', keydownHandler);
                }
            }
        };
        return directiveDefinitionObject;
}]);